import { Security } from '../security/security';
import { Country } from './country';

export class InvestmentJurisdiction {
  investmentJurisdictionId!: number;
  name!: string;
  countryId!: number;
  isActive!: boolean;
  created!: Date;
  createdBy!: string;
  modified!: Date;
  modifiedBy!: string;
  country!: Country;
  securities!: Security[];
}
